import { ICONS } from '@/assets/js/_data'

export default {
  data () {
    return {
      icons: ICONS
    }
  },
  computed: {
    partialBGMax () {
      if (!this.board.results) return 0
      let max = 0
      this.board.results.forEach(res => {
        if (res.data.count && max < res.data.count) max = res.data.count
      })
      return max
    }
  }
}
